import { PuzzleGameStateBaseModel } from './puzzle-game-state-base.model';
import { createSelector } from '@ngxs/store';

export class PuzzleGameBaseState {
  static getByID(puzzleID: string) {
    return createSelector([this], (state: PuzzleGameStateBaseModel) => {
      // const puzzleGame = PuzzleGameState.filterGames(state.puzzleGames, puzzleID, false);
      if (state.puzzleGames.hasOwnProperty(puzzleID)) {
        return state.puzzleGames[puzzleID];
      }
      return null;
    });
  }
}
